<div>
    <h2>{{'centralEstadisticas.titulo' | translate}}</h2>
    <section class="filters-framed-flex">
        <div class="filters-framed-buttons">
            <section>
                <h3>{{'centralEstadisticas.filters.consultarEstadisticas' | translate}} </h3>
                <div class="section-buttons-left">

                    <button [ngClass]="filterPaisDenominacion ? 'primary' : 'secondary'"
                    (click)="filterEstadisticas('PD')"><i class="fa-solid fa-earth-europe"></i> {{'centralEstadisticas.filters.paisDenominacion' | translate}}</button>
                    <button [ngClass]="filterCampanyaPaisDenominacion ? 'primary' : 'secondary'"
                    (click)="filterEstadisticas('CampanyaPD')"><i class="fa-solid fa-calendar-days"></i> {{'centralEstadisticas.filters.campanyaPD' | translate}}</button>
                </div>
            </section>
            <section *ngIf="filterPaisDenominacion">
                <h3>{{'centralEstadisticas.filters.tipoEstadisticas' | translate}} </h3>
                <div class="section-buttons-left">
                    <button [ngClass]="filterEtiquetadores ? 'primary' : 'secondary'"
                        (click)="filterTipo('Etiquetadores')"><i class="fa-solid fa-user-tag"></i> {{'centralEstadisticas.filters.etiquetadores' | translate}}</button>
                    <button [ngClass]="filterDesignacionesPD ? 'primary' : 'secondary'"
                        (click)="filterTipo('DesignacionesPD')"><i class="fas fa-handshake"></i> {{'centralEstadisticas.filters.designaciones' | translate}}</button>
                    <button [ngClass]="filterCultivos ? 'primary' : 'secondary'"
                        (click)="filterTipo('Cultivos')"><i class="fas fa-seedling"></i> {{'global.cultivos' | translate}}</button>
                    <button [ngClass]="filterEtiquetadoPD ? 'primary' : 'secondary'"
                        (click)="filterTipo('EtiquetadoPD')"><i class="fa-solid fa-boxes-stacked"></i> {{'centralEstadisticas.filters.confeccionado' | translate}}</button>
                </div>
            </section>
            <section *ngIf="filterCampanyaPaisDenominacion">
                <h3>{{'centralEstadisticas.filters.tipoEstadisticas' | translate}} </h3>
                <div class="section-buttons-left">
                    <button [ngClass]="filterDesignacionesCPD ? 'primary' : 'secondary'"
                        (click)="filterTipo('DesignacionesCPD')"><i class="fas fa-handshake"></i> {{'centralEstadisticas.filters.designaciones' | translate}}</button>
                    <button [ngClass]="filterEtiquetadoCPD ? 'primary' : 'secondary'"
                        (click)="filterTipo('EtiquetadoCPD')"><i class="fa-solid fa-boxes-stacked"></i> {{'centralEstadisticas.filters.confeccionado' | translate}}</button>
                </div>
            </section>
            <section>
                <div class="section-buttons-right" *ngIf="mostrarFiltrado()">
                    <div class="down">
                        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
                            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
                            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
                        </button>
                    </div>
                </div>
            </section>
        </div>
        <div class="" *ngIf="filtersVisible">
            <form [formGroup]="filtersForm" [ngClass]="{'show-error': showError, 'show-warning': showWarning}">
                <div [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                    <label>{{'centralEstadisticas.filters.anyo' | translate}}{{filtroAnyo ? ' *' : ''}}</label>
                    <app-multiselect-list [itemsList]="filterPaisDenominacion? [] : anyosCampanya" (shareCheckedList)="shareCheckedListCampanyas($event)"
                        [selectedItem]="filtersForm.get('anyoCampanya')"
                        [disabled]="disabledAnyos" [initialState]="initialStateCampanyas">
                    </app-multiselect-list>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'" *ngIf="paises && paises.length > 1">
                    <label>{{'global.pais' | translate}}{{filtroPais ? ' *' : ''}}</label>
                    <app-multiselect-list [itemsList]="paises" (shareCheckedList)="shareCheckedListPaises($event)"
                        [selectedItem]="filtersForm.get('pais')"
                        [disabled]="disabledPaises" [initialState]="initialStatePaises">
                    </app-multiselect-list>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'" *ngIf="paises && paises.length === 1">
                    <label>{{'global.pais' | translate}}{{filtroPais ? ' *' : ''}}</label>
                    <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [disabled]="disabledPaises" [placeHolder]="false">
                    </app-filterable-list>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'" *ngIf="denominaciones && denominaciones.length > 1">
                    <label>{{'centralEstadisticas.filters.denominacion' | translate}}{{filtroDenominacion ? ' *' : ''}}</label>
                    <app-multiselect-list [itemsList]="denominaciones" (shareCheckedList)="shareCheckedListDenominaciones($event)"
                        [selectedItem]="filtersForm.get('denominacion')"
                        [disabled]="disabledDenominaciones" [initialState]="initialStateDenominaciones">
                    </app-multiselect-list>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'" *ngIf="denominaciones && denominaciones.length === 1">
                    <label>{{'centralEstadisticas.filters.denominacion' | translate}}{{filtroDenominacion ? ' *' : ''}}</label>
                    <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                    </app-filterable-list>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                    <label>{{'centralEstadisticas.filters.etiquetador' | translate}}{{filtroEtiquetador ? ' *' : ''}}</label>
                    <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false">
                    </app-filterable-list>
                </div>
            </form>
        </div>
    </section>
    <section class="filters-buttons">
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons" [ngClass]="{'dataInsights': !filtersVisible}">
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <div>
        <form>
            <section class="info-framed-flex" *ngIf="filterEtiquetadores">
                <div class="container">
                    <i class="fa-2x fa-solid fa-user-tag"></i>
                    <div>
                        <label>{{numEtiquetadoresEtq | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.etiquetadores.nEtiquetadores' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-warehouse"></i>
                    <div>
                        <label>{{numAlmacenesEtq | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.etiquetadores.nAlmacenes' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-earth-americas"></i>
                    <div>
                        <label>{{numPaisesEtq | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.etiquetadores.nPaises' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-leaf"></i>
                    <div>
                        <label>{{numDenominacionesEtq | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.etiquetadores.nDenominaciones' | translate}}</span>
                    </div>
                </div>
            </section>
            <section class="info-framed-flex" *ngIf="filterDesignacionesPD || filterDesignacionesCPD">
                <div class="container">
                    <i class="fa-2x fa-solid fa-handshake"></i>
                    <div>
                        <label>{{numDesignacionesDsg | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.designaciones.nDesignaciones' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-earth-americas"></i>
                    <div>
                        <label>{{numPaisesDsg | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.designaciones.nPaises' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-leaf"></i>
                    <div>
                        <label>{{numDenominacionesDsg | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.designaciones.nDenominaciones' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-box"></i>
                    <div>
                        <label>{{designadosDsg | number : '1.2-2': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.designaciones.designadosKg' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-box"></i>
                    <div>
                        <label>{{aforoDsg | number : '1.2-2': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.designaciones.aforoKg' | translate}}</span>
                    </div>
                </div>
            </section>
            <section class="info-framed-flex" *ngIf="filterCultivos">
                <div class="container">
                    <i class=" fa-2x fas fa-seedling"></i>
                    <div>
                        <label>{{numCultivosCul | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.cultivos.nCultivos' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-earth-americas"></i>
                    <div>
                        <label>{{numPaisesCul | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.cultivos.nPaises' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-leaf"></i>
                    <div>
                        <label>{{numDenominacionesCul | number : '1.0-0': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.cultivos.nDenominaciones' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-box"></i>
                    <div>
                        <label>{{aforoCul | number : '1.2-2': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.cultivos.aforoKg' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-vector-square"></i>
                    <div>
                        <label>{{superficieCul | number : '1.2-2': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.cultivos.superficieHa' | translate}}</span>
                    </div>
                </div>
            </section>
            <section class="info-framed-flex" *ngIf="filterEtiquetadoPD || filterEtiquetadoCPD || filterReetiquetado || filterEtiquetas">
                <div class="container">
                    <i class="fa-2x fa-solid fa-handshake"></i>
                    <div>
                        <label>{{totalKilosDesignadosEto | number : '1.2-2': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.etiquetado.designadosKg' | translate}}</span>
                    </div>
                </div>
                <!-- <div class="container">
                    <i class="fa-2x fa-solid fa-truck"></i>
                    <div>
                        <label>{{totalKilosNetosEto | number : '1.2-2': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.etiquetado.campoKg' | translate}}</span>
                    </div>
                </div>
                <div class="container">
                    <i class="fa-2x fa-solid fa-box"></i>
                    <div>
                        <label>{{totalKilosCampoEto | number : '1.2-2': defaultLanguage}}</label>
                        <span>{{'centralEstadisticas.etiquetado.recepcionKg' | translate}}</span>
                    </div>
                </div> -->
                <div class="container">
                    <i class="fa-2x fa-solid fa-box"></i>
                    <div>
                        <label>{{totalKilosExpedicionEto | number : '1.2-2': defaultLanguage}}</label>
                        <span>{{'global.confeccionadoKg' | translate}}</span>
                    </div>
                </div>
            </section>
        </form>
    </div>
    <app-estadisticas-etiquetador *ngIf="filterEtiquetadores" [graficasEtiquetadores]="graficasEtiquetadores" [allDataDesignaciones]="datosEtiquetadores" [filtrado]="filtrado" (showWarning)="checkWarnings($event)"></app-estadisticas-etiquetador>
    <app-estadisticas-designacion-pd *ngIf="filterDesignacionesPD" [graficasDesignaciones]="graficasDesignaciones" [allDataDesignaciones]="datosDesignaciones" [filtrado]="filtrado" (showWarning)="checkWarnings($event)"></app-estadisticas-designacion-pd>
    <app-estadisticas-designacion-cpd *ngIf="filterDesignacionesCPD" [graficasDesignacionesFiltroCompleto]="graficasDesignacionesFiltroCompleto" [filtrado]="filtrado" (showWarning)="checkWarnings($event)"></app-estadisticas-designacion-cpd>
    <app-estadisticas-cultivo *ngIf="filterCultivos" [graficasCultivos]="graficasCultivos" [allDataCultivos]="datosCultivos" [filtrado]="filtrado" (showWarning)="checkWarnings($event)"></app-estadisticas-cultivo>
    <app-estadisticas-etiquetado-cpd *ngIf="filterEtiquetadoCPD" [graficasEtiquetadoFiltroCompleto]="graficasEtiquetadoFiltroCompleto" [filtrado]="filtrado" (showWarning)="checkWarnings($event)"></app-estadisticas-etiquetado-cpd>
    <app-estadisticas-etiquetado-pd *ngIf="filterEtiquetadoPD" [graficasEtiquetado]="graficasEtiquetado" [filtrado]="filtrado" (showWarning)="checkWarnings($event)"></app-estadisticas-etiquetado-pd>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>
